import type React from "react"
import { ErrorBoundary } from "react-error-boundary"

import { ErrorBoundaryFallback } from "./error-boundary-fallback"
import { logError } from "./error-boundary-fallback-utils"

interface ModuleErrorBoundaryProps {
  children: React.ReactNode
  resetKeys: unknown[]
}

export const ModuleErrorBoundary: React.FC<ModuleErrorBoundaryProps> = ({
  children,
  resetKeys,
}) => (
  <ErrorBoundary
    FallbackComponent={ErrorBoundaryFallback}
    onError={logError}
    resetKeys={resetKeys}
  >
    {children}
  </ErrorBoundary>
)
